<template>
    <div class="container">
        <div class="header">
            <i class="icon-fanhui iconfont back"
               @click="back"></i>
            <h2 v-if="type==1">反馈列表</h2>
            <h2 v-if="type==2">反馈详情</h2>
            <h2 v-if="type==3">添加反馈</h2>
            <h2 v-if="type==4">编辑反馈</h2>
            <span @click="subitBug"
                  class="btn"
                  v-if="type==1"> + 添加</span>
        </div>
        <!-- 展示列表页面 type=1 -->
        <div class="content"
             v-if="type==1">
            <!-- 新增tab栏 -->
            <ul style="margin-bottom:0.3rem">
                <!-- <li :class="{'yes' :currentIndex==0}">全部</li> -->
                <li v-for="(item,index) in titleList"
                    :key="index"
                    :class="{'yes' :currentIndex==index}"
                    @click="changeIndex(index)">{{item}}</li>
            </ul>
            <!-- 列表 -->
            <div class="list-wrapper" v-if="bugList.length>0"
                 style="overlow:scroll">
                <div v-for="item in bugList"
                     :key="item.id"
                     @click="showDetail(item.id,item.product)">
                    <mt-cell-swipe   :right="[   {
                                content: '编辑',
                                style: {background: '#6DB0FB', color: '#fff',lineHeight:'3rem' },
                                handler: function(){editPro(item.id,item.product) }
                            },
                            {
                                content: '关闭',
                                style: {background: '#E4BB51', color: '#fff',lineHeight:'3rem' },
                                handler: function(){closeBug(item.id) }
                            },

                         ]">
                        <div class="list-item">
                            <h4 class="bug-list-title">{{item.title}}</h4>
                            <p style="position:relative">
                                <span>时间:{{item.openedDate?item.openedDate.slice(0,10):'--'}}</span>
                                <span class="bug-list-per">创建人:{{item.openedBy}}</span>
                                <span class="bug-list-status color-per"
                                      v-if="item.status=='active'">已激活</span>
                                <span class="bug-list-status color-green"
                                      v-if="item.status=='resolved'">已解决</span>
                                <span class="bug-list-status"
                                      v-if="item.status=='closed'">已关闭</span>
                            </p>
                            <p>
                                <span style="display:inline-block;width:2rem;">指派:{{item.assignedTo}}</span>
                                <span class="bug-list-resolveper">由谁解决:{{item.resolvedBy}}</span>
                            </p>
                            <p>
                                <!-- <span>所属:{{productList[item.product]}}</span> -->
                                <span class="list-pri">优先级:<span class="bug-list-pri">{{priData[(item.pri)-1]}}</span></span>
                            </p>
                            <p v-if="item.message.length>0" style="color:#000">
                                <span>{{item.message[0].date}}</span>
                                <span>{{item.message[0].actor}}</span>
                                <span>{{item.message[0].action}}</span>
                                <span>{{item.message[0].extra}}</span>
                                <span v-if="item.message[0].read==0&&currentIndex==0" class="red_circle">new</span>
                            </p>
                        </div>
                    </mt-cell-swipe>
                </div>
            </div>
            <div  class="list-wrapper"  v-if="bugList.length<=0">
                <nodata></nodata>
            </div>


        </div>
        <!-- 展示详情页面  type=2-->
        <div class="detail"
             v-if="type==2">
            <div class="bugdetails">
                <div class="detail-title">
                    <span class="detail-icon"></span>{{bugDetails.title}}
                </div>
                <div class="detail-created">
                    <span> {{bugDetails.openedDate?bugDetails.openedDate:''}}</span>
                    <span>{{bugDetails.openedBy}}</span>
                </div>
                <div>重现步骤/内容:
                    <div v-html="bugDetails.steps"
                         class="resteps"></div>
                </div>
                <div class="detail-lists">
                    <div>所属产品:<span>{{productList[bugDetails.product]}}</span></div>

                    <div>所属项目:<span>{{bugDetails.project== 0 ? "所有" :proList[bugDetails.project]}}</span></div>
                    <div>所属模块:<span>{{bugDetails.module==0?"所有":moduleList[bugDetails.module]}}</span></div>
                    <!-- <div>影响版本:<span>{{bugDetails.openedBuild==0? "所有":buildList[bugDetails.openedBuild]}}</span></div> -->
                    <!-- <div>严重程度:<span>{{this.priData[(bugDetails.severity)-1]}}</span></div> -->
                    <div>优先级:<span>{{this.priData[(bugDetails.pri)-1]}}</span></div>
                    <div>最后编辑:<span>{{bugDetails.lastEditedBy}}</span></div>
                    <div>最后编辑时间:<span>{{bugDetails.lastEditedDate}}</span></div>
                </div>
                <div class="msg-details">
                    <span class="allmsg">全部留言</span>
                    <ul>
                        <li v-for="(item,index) in historyList"
                            :key="index"
                            style="border-bottom:1px solid #ccc;padding:2px;">
                            <div>
                                <span>{{item.actor}}</span>
                            </div>
                            <div class="c-666">
                                <span>{{item.date}}</span>
                                <span>{{item.action}}</span>
                                <span>{{item.extra}}</span>
                            </div>
                            <div style="font-size:14px;">
                                <span v-html="item.comment"></span>
                            </div>
                        </li>
                         <div v-if="currentIndex==0" class="closebug" @click="closeBug">关闭</div>
                    </ul>
                </div>
            </div>
            <div class="leave-message">

                <div>
                    <input type="text"
                           placeholder="请输入留言"
                           class="msg_in"
                           v-model="leaveMessage.comment" />
                    <span class="sendbtn"
                          @click="sendBtn()">发送</span>
                </div>
            </div>
        </div>
        <!-- 添加 type=3,type==4编辑-->
        <div class="add"
             v-if="type==3||type==4"
             style="position:relative;top:0;left:0;">
            <ul class="addlist">
                <li>
                    <span class=require-icon>*</span>所属产品:
                    <select class="bug-list-select"
                            @change="prodoctChange"
                            v-model="prodoct_id">
                        <option v-for="item in productSelect"
                                :key="item.id"
                                :value="item.id">{{item.name}}</option>
                    </select>
                </li>
                <li>
                    <span class=require-icon>*</span>所属模块:
                    <select v-model="model_id"
                            class="bug-list-select">
                        <option v-for="item in modelSelect"
                                :key="item.id"
                                :value="item.id">{{item.name}}</option>
                    </select>
                </li>
                <li>
                    <span class=require-icon>*</span>所属项目:
                    <select v-model="project_id"
                            class="bug-list-select">
                        <option v-for="item in projectSelect"
                                :key="item.id"
                                :value="item.id">{{item.name}}</option>
                    </select>
                </li>
                <!-- <li>
                    <span class=require-icon>*</span>影响版本:
                    <select v-model="openedBuild"
                            class="bug-list-select">
                        <option v-for="item in openedBuildtSelect"
                                :key="item.id"
                                :value="item.id">{{item.name}}</option>
                    </select>
                </li> -->
                <li>
                    <span class=require-icon>*</span>优先级:
                    <select v-model="pri"
                            class="bug-list-select m-l">
                        <option v-for="(item,index) in priList"
                                :key="index"
                                :value="item.id">{{item.name}}</option>
                    </select>
                </li>
                <!-- <li>
                    <span class=require-icon>*</span>严重程度:
                    <select v-model="severity"
                            class="bug-list-select">
                        <option v-for="(item,index) in severityList"
                                :key="index"
                                :value="item.id">{{item.name}}</option>
                    </select>
                </li> -->
                <li style="min-height:2rem;position:relative;">
                    <span class="require-icon "
                          style="position:absolute;top:0;">*</span><span class="edit-title">标题:</span>
                    <textarea type="text"
                              v-model="title"
                              placeholder="请输入标题"
                              class="bug-title"></textarea>
                </li>
                <li style="height:3.4rem;position:relative;">
                    <span class="require-icon"
                          style="position:absolute;top:0;">*</span><span class="edit-title">内容:</span>

                    <textarea class="bug-content"
                              type="textarea"
                              placeholder="[步骤]请描述操纵步骤;[结果]请描述出现的现象;[期望]描述正常应该出现的结果"
                              v-model="steps"></textarea>
                </li>
                <li style="position:relative">
                    <span style="margin-left:0.2rem;"
                          v-if="imgArr.length<=0">点我上传图片(非必须选)</span>
                    <span style="margin-left:0.2rem;"
                          v-if="imgArr.length>0">点我可以再上传图片哦(非必须选)</span>
                    <form enctype="multipart/form-data"
                          method="post"> 　　
                        　　<input type="file"
                               class="upload-file-wrapper"
                               placeholder="上传"
                               @change="chooseImage"
                               id="file" />
                    </form>

                </li>
                <li style="width:100%;height:100%;position:relative"
                    class="fileimg"
                    v-if="imgArr.length>0"
                    v-for="(item,index) in imgArr"
                    :key="index">
                    <img :src="item"
                         style="display:block;width:100%;height:100%;margin-bottom:5px;" />
                    <span class="closebtn"
                          title="点我取消"
                          @click="closeBtn(index)">x</span>
                </li>

            </ul>
            <div class="bug-list-btn">
                <span @click="cancel"
                      class="cancelbtn"
                      :class="{active:tempcancel==2}">取消</span>
                <span @click="addBug"
                      class="addbtn"
                      :class="{active:tempadd==2}">提交</span>
            </div>
        </div>
        <div class="footer"
             v-if="type==1">
            <span class="perbtn"
                  @click="pervPage()">上一页</span>
            <span class="nextbtn"
                  @click="nextPage()">下一页</span>
            <span>当前页<span class="currentpage">{{allTotals==0?currentPage=0:currentPage}}</span></span>
            <span>总页数<span class="currentpage">{{allTotals}}</span></span>
        </div>
    </div>
</template>
<script>
    import { MessageBox, Loadmore, InfiniteScroll, Indicator } from 'mint-ui';
    import nodata from './public/nodata'
    import utils from "../utils"
    import Vue from 'vue'
    Vue.use(InfiniteScroll);

    Vue.component(Loadmore.name, Loadmore);
    export default {
        components:{
            nodata
        },
        data () {
            return {
              right:  [   {
                                content: '编辑',
                                style: {background: '#6DB0FB', color: '#fff',lineHeight:'2.7rem' },
                                handler: function(){editPro(item.id,item.product) }
                            },
                            {
                                content: '关闭',
                                style: {background: '#E4BB51', color: '#fff',lineHeight:'2.7rem' },
                                handler: function(){closeBug(item.id) }
                            },

                         ],






                type: 1, // 1显示列表 2显示详情
                bugList: [],
                proList: [],//项目列表
                moduleList: [],//模块列表
                productList: [],//所属产品列表
                // buildList: [],//影响版本
                priData: ["高", "中", "低"],//优先级及严重程度级别
                currentIndex: 0,//默认选中状态当前状态下的
                bugDetails: [],//反馈详情信息
                prodoct_id: '1',
                model_id: '',
                project_id: '',
                openedBuild: '',
                pri: '',//优先级
                bug_id: 0,
                // severity: '',//严重程度
                title: '',
                steps: '',
                data1: {//所属项目参数
                    project_id: '1'
                },
                modelSelect: [],//所属模块
                projectSelect: [],
                openedBuildtSelect: [],
                tempcancel: 1,//取消
                tempadd: 1,//提交按钮
                serchData: {
                    productID: 0,
                    page: 1
                },
                currentPage: 1,//当前页数
                allTotals: '',//总数量
                historyList: [],//进度列表数据
                leaveMessage: {//留言参数
                    objectID: '',
                    product: '',
                    project: '',
                    user_id: '',
                    comment: '',
                },
                bugId: '',//详情页面时的id
                imgUrl: '',//上传图片成功后的地址
                imgArr: [],//上传图片成功后的数组
                imgStatus: false,
                list: [],
                //标题数组:
                titleList: ["我的", "Saas", "Boss", "CRM", "名片小程序", "C端小程序", "Ipad", "infimake"],
                productSelect: [
                    {   id: '1',
                        name: 'Saas'
                    },
                    {   id: '2',
                        name: 'Boss'
                    },
                    {   id: '3',
                        name: 'CRM'
                    },
                    {   id: '4',
                        name: '名片小程序'
                    },
                    {   id: '5',
                        name: 'C端小程序'
                    },
                    {   id: '6',
                        name: 'Ipad'
                    },
                    {   id: '7',
                        name: 'infimake'
                    },
                ],
                //优先级
                priList: [
                    {   id: 1,
                        name: '高'
                    },
                    {   id: 2,
                        name: '中'
                    },
                    {   id: 3,
                        name: '低'
                    },
                ],
                //严重程度
                // severityList: [
                //     {                        id: 1,
                //         name: '高'
                //     },
                //     {                        id: 2,
                //         name: '中'
                //     },
                //     {                        id: 3,
                //         name: '低'
                //     },
                // ],

            }
        },
        mounted () {
            let user_id = localStorage.getItem('userId') || ''
            this.serchData.user_id = user_id
            this.getBugList()
            this.getAddView()

        },
        methods: {
            // 上传功能封装
            filesHandle (file, params, callback) {
                var reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = function (e) {
                    var canvasWidth, canvasHeight
                    var image = new Image()
                    image.src = e.target.result
                    image.onload = function (e) {
                        // 获取图片宽高
                        var width = image.width
                        var height = image.height
                        // 大于1m，尺寸缩放
                        if ((file.size / 1024) > 1024) {
                            canvasWidth = width / 2
                            canvasHeight = height / 2
                        } else {
                            canvasWidth = width
                            canvasHeight = height
                        }
                        var canvas = document.createElement('canvas')
                        var ctx = canvas.getContext('2d')
                        canvas.width = canvasWidth
                        canvas.height = canvasHeight
                        ctx.drawImage(image, 0, 0, canvasWidth, canvasHeight)
                        var dataURL = canvas.toDataURL('image/jpeg', 1)
                        var blob = utils.tool.dataURLtoBlob(dataURL)
                        var formdata = new FormData()
                        formdata.append('upfile', blob, "image.jpg")
                        if (params) {
                            formdata.append('type', params)
                        }
                        callback(formdata)
                    }
                }
            },
            chooseImage (e) {//上传图片
                var that = this
                var targetFile = e.target.files[0]
                this.filesHandle(targetFile, '', function (formdata) {
                    Indicator.open({
                        text: '加载中...',
                        spinnerType: 'fading-circle'
                    })
                    that.$http.getUpload(formdata).then(res => {
                        if (res.state == "SUCCESS") {
                            Indicator.close()
                            that.imgUrl = res.url
                            that.imgStatus = true
                            that.$notice.tip("选择图片成功")
                            that.imgArr.push(res.url)

                        }
                    })

                })
            },

            // 获取列表
            getBugList () {
                this.serchData.productID = this.currentIndex;
                this.$http.getBugList(this.serchData).then(res => {
                    this.currentPage = res.data.bugList.current_page,//当前页数
                    this.allTotals = res.data.bugList.last_page//总数量
                    this.bugList = res.data.bugList.data//bug列表
                    this.proList = res.data.project//产品列表
                    this.moduleList = res.data.module//所属模块列表
                    this.productList = res.data.product//所属产品列表
                    this.buildList = res.data.build
                })
            },
            getHistory () {
                this.$http.getBugHistory({ bID: this.bugId }).then(res => {
                    this.historyList = res.data.history
                })
            },
            // 显示详情，调转到详情页面
            showDetail (bugId, pid) {
                this.data1.project_id = pid
                this.getAddView()
                this.type = 2
                this.bugId = bugId
                this.$http.getBugDetail({ bug_id: bugId }).then(res => {
                    this.bugDetails = res.data.bugDetail
                    this.leaveMessage.objectID = res.data.bugDetail.id //id值
                    this.leaveMessage.product = res.data.bugDetail.product//赋值
                    this.leaveMessage.project = res.data.bugDetail.project
                })

                this.getHistory()

            },
            // 添加bug按钮
            subitBug () {
                this.type = 3
                //清空数据
                this.prodoct_id = '';
                this.model_id = '';
                this.project_id = '';
                this.openedBuild = '';
                this.pri = '';//优先级
                this.bug_id = 0;
                // this.severity = '';//严重程度
                this.title = '';
                this.steps = '';
                this.imgArr = [];//清空
                this.tempadd = 1
                this.tempcancel = 1

            },
            // 返回上一页
            back () {

                if (this.type === 1) { // 当前在列表页，返回上级路由
                    this.$router.push({ name: 'my' })
                }
                else if (this.type === 2) { // 当前在详情页，返回列表
                    this.type = 1
                    this.getBugList()
                    //  this.$router.push({ name: 'buglist' })
                }
                else if (this.type === 3) {
                    this.type = 1
                }
                else if (this.type === 4) {
                    this.type = 1
                }

            },
            //编辑当条数据  //展示编辑信息
            editPro (bugId, pid) {
                this.type = 4
                this.$http.getBugDetail({ bug_id: bugId }).then(res => {
                    if (res.errCode == 0) {
                        this.prodoct_id = res.data.bugDetail.product
                        this.project_id = res.data.bugDetail.project
                        this.model_id = res.data.bugDetail.module
                        // this.severity = res.data.bugDetail.severity//严重程度2
                        // this.openedBuild = (res.data.bugDetail.openedBuild)//影响版本
                        this.pri = res.data.bugDetail.pri
                        this.os = res.data.bugDetail.os
                        this.browser = res.data.bugDetail.browser
                        this.title = res.data.bugDetail.title
                        this.steps = res.data.bugDetail.steps.split('<p>')[0]
                        this.bug_id = res.data.bugDetail.id//bug_id
                        this.imgArr = res.data.bugDetail.linkBug ? res.data.bugDetail.linkBug : []//展示当前的图片
                    }else {
                        this.$notice.tip(res.errMsg)
                    }
                })
                this.data1.project_id = pid
                this.getAddView()
            },
            //关闭按钮
            closeBug(bugId){
                console.log('bugid',bugId)
                if(this.currentIndex!=0){
                     MessageBox(' 提示','您当前无权限关闭！')
                     return
                }
                // MessageBox(' 提示','确定')
                MessageBox.confirm('确认该问题已经完美解决 ？已经解决请点击确认关闭！').then(action => {
                    this.$http.closeBug({id:bugId}).then(res=>{
                      if(res.errCode == '1001'){
                          MessageBox('提示',res.errMsg)
                      }else{
                           MessageBox('提示','关闭成功')
                      }
                    })
                    },cancel=>{
                       console.log('点击了关闭的提示的取消按钮')
                    });
            },
            // 点击所属产品的下标
            changeIndex (index) {
                if (index == 0) {
                    let user_id = localStorage.getItem('userId') || ''
                    this.serchData.user_id = user_id
                    this.serchData.productID = ''
                    this.serchData.page = 1
                    if (!user_id) {
                        return false
                    }
                } else {
                    this.currentIndex = index
                    this.serchData.page = 1
                    this.serchData.user_id = ''
                }
                this.currentIndex = index
                this.serchData.page = 1

                this.getBugList()
            },
            //改变所属产品
            prodoctChange () {
                this.data1.project_id = this.prodoct_id
                this.getAddView()
            },
            //选择所属产品时触发改变所属项目及等
            getAddView () {
                this.$http.getAddView(this.data1).then((res) => {
                    this.modelSelect = res.data.model
                    this.projectSelect = res.data.project
                    this.openedBuildtSelect = res.data.openedBuild
                })
            },
            //  保存接口
            addBug () {
                this.tempadd = 2
                let user_id = localStorage.getItem('userId') || ''
                if (!user_id) {
                    return false
                }
                this.addData = {
                    bug_id: this.bug_id,
                    user_id: user_id,
                    product: this.prodoct_id,
                    project: this.project_id,
                    module: this.model_id,
                    // severity: this.severity,//严重程度2
                    openedBuild: this.openedBuild,
                    pri: this.pri,
                    assignedTo: "alan",//当前指派（固定值）
                    title: this.title,
                    steps: this.steps,
                    imgsrc: this.imgArr
                }
                this.$http.addBug(this.addData).then(res => {
                    if (res.errCode == 0) {
                        this.$notice.tip('提交成功')
                        this.imgStatus = false
                        this.type = 1
                        this.getBugList()
                        this.tempadd = 1
                        this.tempcancel = 1
                    } else {
                        this.$notice.tip(`${res.errMsg}`)
                    }
                })
            },
            // 取消按钮
            cancel () {
                this.tempcancel = 2
                this.type = 1
            },
            //点击图片上的关闭按钮
            closeBtn (index) {
                this.imgArr.splice(index, 1)
            },
            sendBtn () {
                this.leaveMessage.user_id = localStorage.getItem('userId') || ''
                this.$http.getMessage(this.leaveMessage).then(res => {
                    if (res.errCode == 0) {
                        this.$notice.tip('留言成功')
                        this.leaveMessage.comment = ""
                        this.getHistory()//刷新界面
                    } else {
                        this.$notice.tip(res.errMsg)
                    }
                })
            },

            //下一页
            nextPage () {
                this.serchData.page = this.currentPage + 1
                if (this.serchData.page > this.allTotals) {
                    this.serchData.page = this.allTotals
                    if (this.serchData.page == this.allTotals) {
                        this.$notice.tip('已经是最后一页，没有更多数据')
                    }

                }
                this.getBugList()
            },
            //上一页
            pervPage () {
                this.serchData.page = this.currentPage - 1
                // console.log(this.currentPage + 1)
                if (this.serchData.page <= 0) {
                    this.serchData.page = 1
                    if (this.serchData.page = 1) {
                        this.$notice.tip('已经是第一页,请点击下一页')
                    }
                }
                this.getBugList()
            }

        },

    }
</script>

<style  scoped>
    .upload-file-wrapper {
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
    }
    .container {
      color: #333;
      width: 100vw;
      height: 100vh;
      font-family: PingFangSC-Regular;
    }
    .header {
      width: 100%;
      color: #000;
      text-align: center;
      font-size: 0.375rem;
      background-color: #fff;
      height: 7%;
      position: relative;
    }
    .header h2 {
      color: #333;
      font-size: 0.4375rem;
      border-bottom: 1px solid #ddd;
      height: 100%;
      padding-top: 3.5%;
    }
    .header .btn {
      position: absolute;
      right: 0.3125rem;
      top: 20%;
      color: #5483d2;
    }
    .back {
      display: inline-block;
      position: absolute;
      left: 0.3125rem;
      top: 18%;
      font-weight: bold;
      height: 0.78125rem;
      line-height: 0.78125rem;
      color: #86898e;
    }
    .list-wrapper {
      overflow: scroll;
      padding-bottom: 3.8rem;

    }
    .list-item {
      font-size: 12px;
      color: #666;
      border-radius: 0.0625rem;
      border-left: 0.09375rem solid #5482d2;
      margin-left: -2px;
      width: 10rem;
      padding: 0.3rem 0.1rem 0.1rem 0.1rem;
      border-bottom:10px;

    }
    .list-item > p {
      margin: 0.35rem 0;
    }
    .bug-list-title {
      font-weight: 600;
      font-size: 14px;
      color: #353535;
      word-wrap: break-word;
      word-break: normal;
      padding-right: 1rem;
    }
    .bug-list-time {
      float: left;
    }
    .bug-list-per {
      margin-left: 1.2rem;
    }
    .bug-list-resolveper {
      margin-left: 1.6rem;
    }
    .bug-list-status {
      margin-top: 0.1rem;
      font-size: 12px;
      color: #5483d2;
      border: 1px solid #5483d2;
      border-radius: 2px;
      padding: 0.1rem 0.2rem;
      position: absolute;
      right: 1rem;
    }
    .edit-title{
      position:absolute;
      left:0.5rem;
      z-index:10
    }
    .color-per{
        color:#7744FF ;
    }
    .color-green{
        color:#00AA00
    }

    .bug-list-status span {
      display: inline-block;
      margin-right: 0.7rem;
    }
    .bug-detail {
      width: 100%;
      min-height: 3rem;
    }
    .bug-detail h3 {
      margin: 0.2rem 0;
      font-size: 14px;
      text-align: center;
    }
    .bug-detail-info {
      font-size: 12px;
      text-align: left;
      color: #666;
    }
    .list-pri {
      float: right;
      margin-right: 1.2rem;
    }
    .bug-list-pri {
      border: 1px solid #fb2e45;
      display: inline-block;
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
      line-height: 0.5rem;
      text-align: center;
      color: #fb2e45;
    }
    .yes {
      border-bottom: 0.0625rem solid #5483d2;
    }
    .content {
      width: 100%;
      height: auto;
      overflow: hidden;
    }
    .content ul {
      white-space: nowrap;
      overflow-x: scroll;
      width: 100%;
      height: auto;
    }
    .content ul li {
      display: inline-block;
      min-width: 1.6rem;
      height: 1.2rem;
      line-height: 1.2rem;
      padding: 0 0.4rem;
      font-size: 0.3375rem;
      text-align: center;
    }
    /* 详情页面的样式 */
    .bugdetails {
      /* height: 700px; */
      padding: 0 0 2rem;
      overflow: scroll;
    }
    .bugdetails > div {
      margin: 0.2rem;
    }
    .detail-title {
      font-size: 16px;
    }
    .detail-icon {
      display: inline-block;
      width: 6px;
      height: 20px;
      background: #5482d2;
      margin-right: 6px;
    }
    .detail-created {
      color: #999;
      border-bottom: 1px solid #ccc;
      font-size: 12px;
      padding-bottom: 2px;
    }
    .detail-lists {
      background: #eee;
      padding: 4px;
      border-radius: 10px;
    }
    .detail-lists > div {
      padding: 2px;
    }
    .detail-step {
      font-size: 12px;
      color: #fff;
      border: 1px solid #ccc;
      padding: 2px;
      border-radius: 10px;
      background: #ccc;
    }
    .c-666 {
      color: #666;
    }
    .bugdetails .msg-details {
      margin-top: 1rem;
    }
    .allmsg {
      padding: 2px 15px 2px;
      color: #fff;
      position: relative;
      left: -18px;
      background: #5483d2;
      border-radius: 10px;
      display: inline-block;
      margin-bottom: 10px;
    }
    /* bug提价按钮 */
    .add li {
      border-bottom: 1px solid #ccc;
      height: 1.2rem;
      line-height: 1.2rem;
      cursor: pointer;
    }
    .bug-list-select {
      min-width: 6.6rem;
      background: #fff;
    }
    .m-l {
      margin-left: 0.4rem;
    }
    .select {
      width: 2.4rem;
    }
    .require-icon {
      color: #fb2e45;
      margin-right: 0.1rem;
      margin-left: 0.2rem;
    }
    .r-position {
      position: relative;
      left: 1px;
      z-index: 10;
    }
    .bug-list-btn {
      margin-top: 0.5rem;
      padding-left: 0.5rem;
    }
    .cancelbtn,
    .addbtn {
      float: left;
      width: 39%;
      margin: 0.4rem;
      border: 1px solid #ccc;
      border-radius: 2rem;
      padding: 0.2rem;
      text-align: center;
    }
    .active {
      border-color: #5483d2;
      color: #5483d2;
    }
    .bug-title {
      min-width: 7.8rem;
      margin-left: 1.5rem;
      min-height: 1.2rem;
      position: relative;
      top: 0.3rem;
      left: 0.5rem;
    }
    .bug-content {
      min-width: 7.8rem;
      margin-left: 1.5rem;
      min-height: 3rem;
      position: relative;
      top: 0.3rem;
      left: 0.5rem;
    }
    .closebug{
        margin-top:0.5rem;
        width:1.3rem;
        height:0.8rem;
        line-height: 0.8rem;
        text-align: center;
       background:#E4BB51;
       color:#fff;
       border-radius: 10px;

    }
    /* 留言弹窗 */
    .leave-message {
      position: absolute;
      bottom: 0;
      width: 100%;
      background: #fff;
      height: 1.5rem;
      padding: 10px;
    }
    .msg_in {
      width: 100%;
      border-radius: 0.3rem;
      border: 1px solid #ccc;
      height: 1rem;
      width: 80%;
      margin-left: 0.2rem;
      padding-left: 0.1rem;
    }
    .sendbtn {
      display: inline-block;
      background: #5483d2;
      display: inline-block;
      width: 1.2rem;
      height: 0.9rem;
      line-height: 0.9rem;
      text-align: center;
      border-radius: 20%;
      color: #fff;
    }
    .footer {
      position: absolute;
      bottom: 0;
      background: #fff;
      padding-left: 0.2rem;
      width: 100%;
      height: 1.3rem;
      line-height: 1.3rem;
    }
    /*上一页及下一页按钮 */
    .perbtn,
    .nextbtn {
      position: relative;
      display: inline-block;
      width: 1.2rem;
      height: 1rem;
      line-height: 1rem;
      font-weight: 600;
      border-radius: 10px;
      border: 1px solid #5483d2;
      text-align: center;
      margin-left: 1rem;
      color: #5483d2;
    }
    .nextbtn {
      margin-right: 1rem;
    }
    .currentpage {
      font-size: 16px;
      margin: 0 5px;
    }
    /* 获取上传图片之后设置图片的样式 */
    .resteps /deep/ img {
      display: block;
      padding: 10px 10px 10px 5px;
      width:100%;
      height:100%;
    }
    .fileimg /deep/ img {
      display: block;
      height: 100%;
     }

    .closebtn{
      display: block;
      width: 0.6rem;
      height: 0.6rem;
      border: 2px solid #ccc;
      border-radius: 50%;
      font-size: 18px;
      line-height: 0.5rem;
      text-align: center;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 100;
      background: #000;
      color: #fff;
    }
    .red_circle{
        background:red;
        color:#fff;
        border-radius: 4px;
        padding:0 2px;
        margin-left:5px;
    }
    .list-wrapper /deep/ a{
        text-decoration:none;
    }
    .list-wrapper /deep/ .mint-cell-wrapper{
       background:#fff;

    }
</style>





// WEBPACK FOOTER //
// src/components/BugList.vue